import { Dialog } from '@radix-ui/react-dialog'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import z from 'zod'
import { PlanAbsenceDialog } from '@/components/organisms/staff-schedule/plan-absence-dialog'

const searchSchema = z.object({
  date: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .optional(),
  userId: z.string().optional(),
})

export const Route = createFileRoute('/_authenticated/schedule/plan-absence/$workshop')({
  validateSearch: searchSchema,
  component: RouteComponent,
})

function RouteComponent() {
  const { workshop } = Route.useParams()
  const { date, userId } = Route.useSearch()
  const navigate = useNavigate()

  const closeDialogue = () => navigate({ to: '/schedule' })

  return (
    <Dialog
      open
      onOpenChange={open => {
        if (!open) closeDialogue()
      }}
    >
      <PlanAbsenceDialog
        workshopId={workshop}
        selectedDate={date}
        userId={userId}
        onClose={closeDialogue}
      />
    </Dialog>
  )
}
